<template>
    <base-modal :modal-title="'Edit Tag'" @save="save()" @close="close()">
        <FormulateForm>
            <FormulateInput type="text" v-model.trim="tagModel.name" label="Name" validation="required" />
            <FormulateInput type="textarea" v-model="tagModel.description" label="Description" />
        </FormulateForm>
    </base-modal>
</template>


<script>
// Load the full build. 
 var _ = require('lodash');
 
 import BaseModal from 'components/modals/BaseModal';
 
 export default {
     components: {
         BaseModal
     },
     props: {
         tag: {
             type: Object,
             default () {
                 return {
                     name: '',
                     description: ''
                 };
             }
         },
     },
     
     data () {
         return {
             tagModel: null
         };
     },
     
     created () {
         this.tagModel = _.clone(this.tag, true);
     },
     computed: {
     },
     methods: {
         close() {
             this.$emit('close');
         },
         save() {
             var requestData = {};
             
             // ID
             if (this.tagModel.id) {
                 requestData.id = this.tagModel.id;
             }
             // Name
             if (this.tagModel.name) {
                 requestData.name = this.tagModel.name;
             }
             if (this.tagModel.description) {
                 requestData.description = this.tagModel.description;
             }
             
             if (requestData.name) {
                 var self = this;
                 API.tags.save(requestData)
                    .then(function (response) {
                        // closing modal
                        self.$emit('close', true);
                    });
             }
         }
     }
 }
</script>


<style>
</style>



// WEBPACK FOOTER //
// TagModal.vue?58a1a284